import { template } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { on } from '@ember/modifier';
import { element } from 'ember-element-helper';
import { consume, provide } from 'ember-provide-consume-context';
import styles from '@hokulea/core/layouts.module.css';
import typo from '@hokulea/core/typography.module.css';
import { or } from '../-private/helpers';
import type { TOC } from '@ember/component/template-only';
import type { Link } from 'ember-link';
interface NavLinkSignature {
    Args: {
        link: Link;
    };
    Blocks: {
        default: [];
    };
}
const NavLink: TOC<NavLinkSignature> = template(`
  <a href={{@link.url}} {{on "click" @link.open}} aria-current={{if @link.isActive "page"}}>
    <span>
      {{yield}}
    </span>
  </a>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
let PageElement = class PageElement extends Component<{
    Element: HTMLElement;
    Blocks: {
        default: [];
    };
}> {
    @consume('page-root')
    useMain: boolean;
    @provide('page-inside')
    get pageInside() {
        return true;
    }
    static{
        template(`
    {{#let (element (if this.useMain "main" "section")) as |Element|}}
      <Element ...attributes>
        {{yield}}
      </Element>
    {{/let}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
};
interface PageSignature {
    Element: HTMLElement;
    Args: {
        title?: string;
        description?: string;
    };
    Blocks: {
        title?: [];
        description?: [];
        nav?: [typeof NavLink];
        content?: [];
        default?: [];
    };
}
let Page = class Page extends Component<PageSignature> {
    @consume('page-inside')
    insidePage: boolean;
    @provide('page-root')
    get rootPage() {
        return this.insidePage ? false : true;
    }
    static{
        template(`
    <PageElement class={{styles.page}} ...attributes data-test-page>
      {{#if
        (or @title @description (has-block "title") (has-block "description") (has-block "nav"))
      }}
        <header class={{styles.pageContent}}>
          <h1 class={{typo.display}}>
            {{#if (has-block "title")}}
              {{yield to="title"}}
            {{else if @title}}
              {{@title}}
            {{/if}}
          </h1>

          {{#if (or (has-block "description") @description)}}
            <p>
              {{#if (has-block "description")}}
                {{yield to="description"}}
              {{else if @description}}
                {{@description}}
              {{/if}}
            </p>
          {{/if}}

          {{#if (has-block "nav")}}
            <nav>
              {{yield NavLink to="nav"}}
            </nav>
          {{/if}}
        </header>
      {{/if}}

      <div class="{{styles.pageContent}} {{styles.flow}}" part="content">
        {{yield to="content"}}
        {{yield}}
      </div>
    </PageElement>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
};
export default Page;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2hva3VsZWEvaG9rdWxlYS9lbWJlci9wYWNrYWdlL3NyYy9jb21wb25lbnRzL3BhZ2UuZ3RzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBDb21wb25lbnQgZnJvbSAnQGdsaW1tZXIvY29tcG9uZW50JztcbmltcG9ydCB7IG9uIH0gZnJvbSAnQGVtYmVyL21vZGlmaWVyJztcblxuaW1wb3J0IHsgZWxlbWVudCB9IGZyb20gJ2VtYmVyLWVsZW1lbnQtaGVscGVyJztcbmltcG9ydCB7IGNvbnN1bWUsIHByb3ZpZGUgfSBmcm9tICdlbWJlci1wcm92aWRlLWNvbnN1bWUtY29udGV4dCc7XG5cbmltcG9ydCBzdHlsZXMgZnJvbSAnQGhva3VsZWEvY29yZS9sYXlvdXRzLm1vZHVsZS5jc3MnO1xuaW1wb3J0IHR5cG8gZnJvbSAnQGhva3VsZWEvY29yZS90eXBvZ3JhcGh5Lm1vZHVsZS5jc3MnO1xuXG5pbXBvcnQgeyBvciB9IGZyb20gJy4uLy1wcml2YXRlL2hlbHBlcnMnO1xuXG5pbXBvcnQgdHlwZSB7IFRPQyB9IGZyb20gJ0BlbWJlci9jb21wb25lbnQvdGVtcGxhdGUtb25seSc7XG5pbXBvcnQgdHlwZSB7IExpbmsgfSBmcm9tICdlbWJlci1saW5rJztcblxuaW50ZXJmYWNlIE5hdkxpbmtTaWduYXR1cmUge1xuICBBcmdzOiB7XG4gICAgbGluazogTGluaztcbiAgfTtcbiAgQmxvY2tzOiB7XG4gICAgZGVmYXVsdDogW107XG4gIH07XG59XG5cbmNvbnN0IE5hdkxpbms6IFRPQzxOYXZMaW5rU2lnbmF0dXJlPiA9IDx0ZW1wbGF0ZT5cbiAgPGEgaHJlZj17e0BsaW5rLnVybH19IHt7b24gXCJjbGlja1wiIEBsaW5rLm9wZW59fSBhcmlhLWN1cnJlbnQ9e3tpZiBAbGluay5pc0FjdGl2ZSBcInBhZ2VcIn19PlxuICAgIDxzcGFuPlxuICAgICAge3t5aWVsZH19XG4gICAgPC9zcGFuPlxuICA8L2E-XG48L3RlbXBsYXRlPjtcblxuY2xhc3MgUGFnZUVsZW1lbnQgZXh0ZW5kcyBDb21wb25lbnQ8eyBFbGVtZW50OiBIVE1MRWxlbWVudDsgQmxvY2tzOiB7IGRlZmF1bHQ6IFtdIH0gfT4ge1xuICBAY29uc3VtZSgncGFnZS1yb290JykgZGVjbGFyZSB1c2VNYWluOiBib29sZWFuO1xuXG4gIEBwcm92aWRlKCdwYWdlLWluc2lkZScpXG4gIGdldCBwYWdlSW5zaWRlKCkge1xuICAgIHJldHVybiB0cnVlO1xuICB9XG5cbiAgPHRlbXBsYXRlPlxuICAgIHt7I2xldCAoZWxlbWVudCAoaWYgdGhpcy51c2VNYWluIFwibWFpblwiIFwic2VjdGlvblwiKSkgYXMgfEVsZW1lbnR8fX1cbiAgICAgIDxFbGVtZW50IC4uLmF0dHJpYnV0ZXM-XG4gICAgICAgIHt7eWllbGR9fVxuICAgICAgPC9FbGVtZW50PlxuICAgIHt7L2xldH19XG4gIDwvdGVtcGxhdGU-XG59XG5cbmludGVyZmFjZSBQYWdlU2lnbmF0dXJlIHtcbiAgRWxlbWVudDogSFRNTEVsZW1lbnQ7XG4gIEFyZ3M6IHtcbiAgICB0aXRsZT86IHN0cmluZztcbiAgICBkZXNjcmlwdGlvbj86IHN0cmluZztcbiAgfTtcbiAgQmxvY2tzOiB7XG4gICAgdGl0bGU_OiBbXTtcbiAgICBkZXNjcmlwdGlvbj86IFtdO1xuICAgIG5hdj86IFt0eXBlb2YgTmF2TGlua107XG4gICAgY29udGVudD86IFtdO1xuICAgIGRlZmF1bHQ_OiBbXTtcbiAgfTtcbn1cblxuY2xhc3MgUGFnZSBleHRlbmRzIENvbXBvbmVudDxQYWdlU2lnbmF0dXJlPiB7XG4gIEBjb25zdW1lKCdwYWdlLWluc2lkZScpIGRlY2xhcmUgaW5zaWRlUGFnZTogYm9vbGVhbjtcblxuICBAcHJvdmlkZSgncGFnZS1yb290JylcbiAgZ2V0IHJvb3RQYWdlKCkge1xuICAgIHJldHVybiB0aGlzLmluc2lkZVBhZ2UgPyBmYWxzZSA6IHRydWU7XG4gIH1cblxuICA8dGVtcGxhdGU-XG4gICAgPFBhZ2VFbGVtZW50IGNsYXNzPXt7c3R5bGVzLnBhZ2V9fSAuLi5hdHRyaWJ1dGVzIGRhdGEtdGVzdC1wYWdlPlxuICAgICAge3sjaWZcbiAgICAgICAgKG9yIEB0aXRsZSBAZGVzY3JpcHRpb24gKGhhcy1ibG9jayBcInRpdGxlXCIpIChoYXMtYmxvY2sgXCJkZXNjcmlwdGlvblwiKSAoaGFzLWJsb2NrIFwibmF2XCIpKVxuICAgICAgfX1cbiAgICAgICAgPGhlYWRlciBjbGFzcz17e3N0eWxlcy5wYWdlQ29udGVudH19PlxuICAgICAgICAgIDxoMSBjbGFzcz17e3R5cG8uZGlzcGxheX19PlxuICAgICAgICAgICAge3sjaWYgKGhhcy1ibG9jayBcInRpdGxlXCIpfX1cbiAgICAgICAgICAgICAge3t5aWVsZCB0bz1cInRpdGxlXCJ9fVxuICAgICAgICAgICAge3tlbHNlIGlmIEB0aXRsZX19XG4gICAgICAgICAgICAgIHt7QHRpdGxlfX1cbiAgICAgICAgICAgIHt7L2lmfX1cbiAgICAgICAgICA8L2gxPlxuXG4gICAgICAgICAge3sjaWYgKG9yIChoYXMtYmxvY2sgXCJkZXNjcmlwdGlvblwiKSBAZGVzY3JpcHRpb24pfX1cbiAgICAgICAgICAgIDxwPlxuICAgICAgICAgICAgICB7eyNpZiAoaGFzLWJsb2NrIFwiZGVzY3JpcHRpb25cIil9fVxuICAgICAgICAgICAgICAgIHt7eWllbGQgdG89XCJkZXNjcmlwdGlvblwifX1cbiAgICAgICAgICAgICAge3tlbHNlIGlmIEBkZXNjcmlwdGlvbn19XG4gICAgICAgICAgICAgICAge3tAZGVzY3JpcHRpb259fVxuICAgICAgICAgICAgICB7ey9pZn19XG4gICAgICAgICAgICA8L3A-XG4gICAgICAgICAge3svaWZ9fVxuXG4gICAgICAgICAge3sjaWYgKGhhcy1ibG9jayBcIm5hdlwiKX19XG4gICAgICAgICAgICA8bmF2PlxuICAgICAgICAgICAgICB7e3lpZWxkIE5hdkxpbmsgdG89XCJuYXZcIn19XG4gICAgICAgICAgICA8L25hdj5cbiAgICAgICAgICB7ey9pZn19XG4gICAgICAgIDwvaGVhZGVyPlxuICAgICAge3svaWZ9fVxuXG4gICAgICA8ZGl2IGNsYXNzPVwie3tzdHlsZXMucGFnZUNvbnRlbnR9fSB7e3N0eWxlcy5mbG93fX1cIiBwYXJ0PVwiY29udGVudFwiPlxuICAgICAgICB7e3lpZWxkIHRvPVwiY29udGVudFwifX1cbiAgICAgICAge3t5aWVsZH19XG4gICAgICA8L2Rpdj5cbiAgICA8L1BhZ2VFbGVtZW50PlxuICA8L3RlbXBsYXRlPlxufVxuXG5leHBvcnQgZGVmYXVsdCBQYWdlO1xuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxPQUFPLGVBQWUscUJBQXFCO0FBQzNDLFNBQVMsRUFBRSxRQUFRLGtCQUFrQjtBQUVyQyxTQUFTLE9BQU8sUUFBUSx1QkFBdUI7QUFDL0MsU0FBUyxPQUFPLEVBQUUsT0FBTyxRQUFRLGdDQUFnQztBQUVqRSxPQUFPLFlBQVksbUNBQW1DO0FBQ3RELE9BQU8sVUFBVSxzQ0FBc0M7QUFFdkQsU0FBUyxFQUFFLFFBQVEsc0JBQXNCO0FBRXpDLGNBQWMsR0FBRyxRQUFRLGlDQUFpQztBQUMxRCxjQUFjLElBQUksUUFBUSxhQUFhO1VBRTdCO0lBQ1I7UUFDRSxNQUFNOztJQUVSO1FBQ0U7OztBQUlKLE1BQU0sU0FBUyxJQUFJLG9CQUFvQixTQUFVLENBQUE7Ozs7OztBQU1qRCxDQUFBLEVBQUE7SUFBQTtRQUFBLE9BQUEsS0FBQSxTQUFBLENBQUEsRUFBVztJQUFEO0FBQUE7QUFFVixJQUFBLEFBQU0sY0FBTixNQUFNLG9CQUFvQjtJQUFZLFNBQVM7SUFBYTtRQUFVOzs7SUFDcEUsQ0FBQyxRQUFRO0lBQXFCLFNBQVMsT0FBTyxDQUFDO0lBRS9DLENBQUMsUUFBUTtJQUFjLElBQ25CLGFBQWE7UUFDZixPQUFPO0lBQ1Q7SUFFQSxNQUFBO1FBQUEsU0FBVSxDQUFBOzs7Ozs7RUFNVixDQUFBLEVBQUE7WUFBQSxXQUFBLElBQVc7WUFBWDtnQkFBQSxPQUFBLEtBQUEsU0FBQSxDQUFBLEVBQVc7WUFBRDtRQUFBO0lBQUEsQ0FOQTtBQU9aO1VBRVU7SUFDUixTQUFTO0lBQ1Q7UUFDRSxRQUFRLE1BQU07UUFDZCxjQUFjLE1BQU07O0lBRXRCO1FBQ0U7UUFDQTtRQUNBLGNBQWM7UUFDZDtRQUNBOzs7QUFJSixJQUFBLEFBQU0sT0FBTixNQUFNLGFBQWEsVUFBVTtJQUMzQixDQUFDLFFBQVE7SUFBdUIsWUFBWSxPQUFPLENBQUM7SUFFcEQsQ0FBQyxRQUFRO0lBQVksSUFDakIsV0FBVztRQUNiLE9BQU8sSUFBSSxDQUFDLFVBQVUsR0FBRyxRQUFRO0lBQ25DO0lBRUEsTUFBQTtRQUFBLFNBQVUsQ0FBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztFQXFDVixDQUFBLEVBQUE7WUFBQSxXQUFBLElBQVc7WUFBWDtnQkFBQSxPQUFBLEtBQUEsU0FBQSxDQUFBLEVBQVc7WUFBRDtRQUFBO0lBQUEsQ0FyQ0E7QUFzQ1o7QUFFQSxlQUFlLEtBQUsifQ